import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from '@/lib/locales'
import { useAppStore } from '@/lib/app-store'
import { trpc } from '@/main'

export const Route = createFileRoute('/_landing/cookies-policy')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      trpc.legal.getDocument.queryOptions({ document: 'cookies-policy', locale: useAppStore.getState().store.locale }),
    ),
  component: RouteComponent,
  pendingComponent: () => <div className="mx-auto max-w-4xl p-8" />,
})

function RouteComponent() {
  const { language } = useTranslation()
  const { data } = useSuspenseQuery(
    trpc.legal.getDocument.queryOptions({ document: 'cookies-policy', locale: language }),
  )

  return (
    <article
      className="unreset-tailwind mx-auto max-w-4xl p-8 break-words"
      // Trusted first-party content: build-time, repo-authored markdown (server legal/content/*/*.md)
      // bundled via Vite `?raw` + rendered with `marked` — there is no user-controlled input path.
      // react-doctor-disable-next-line react-doctor/dangerous-html-sink -- trusted build-time legal HTML
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  )
}
